export enum FieldVisibilityOption {
  NotVisible = 'NotVisible',
  Visible = 'Visible',
  VisibleEditable = 'VisibleEditable',
}

export enum FieldName {
  OrderNo,
  ClientRequestId,
  TRN,
  LotNo,
}

export enum ProductName {
  QestFieldScheduler,
  QestFieldTests,
}

export interface IOptionalWorkOrderFieldsModel {
  ClientRequestId: FieldVisibilityOption;
  LotNo: FieldVisibilityOption;
  OrderNo: FieldVisibilityOption;
  TRN: FieldVisibilityOption;
}

export interface IWorkOrderFieldVisibilityGrid {
  Label: string;
  Product: ProductName;
  Data: {
    QestFieldScheduler: IOptionalWorkOrderFieldsModel;
    QestFieldTests: IOptionalWorkOrderFieldsModel;
  };
  Disabled: boolean;
}
